import type { ISectionOptions } from 'docx';
import { Header } from 'docx';
import type { Editor } from 'slate';

import type { DocumentContext } from './internal';
import { createDocxChildren } from './internal';
import { HeaderType, Queries } from '../../../slate-api';

export function createDocxHeaders(
  editor: Editor,
  options: { context: DocumentContext }
): ISectionOptions['headers'] {
  /**
   * ToDo: Fix links in headers.  Broken due to bug in DOCX library.  See GitHub issue - https://github.com/dolanmiu/docx/issues/532.
   *  Ticket - https://arity.atlassian.net/browse/AR-860.
   */
  const headersEntry = Queries.getHeadersElement(editor);
  if (!headersEntry) return;

  const defaultHeaderEntry = Queries.getHeaderOrFooter({
    editor,
    partEntry: headersEntry,
    type: HeaderType.Default,
  });
  const firstPageHeaderEntry = Queries.getHeaderOrFooter({
    editor,
    partEntry: headersEntry,
    type: HeaderType.FirstPage,
  });
  const evenHeaderEntry = Queries.getHeaderOrFooter({
    editor,
    partEntry: headersEntry,
    type: HeaderType.Even,
  });

  return {
    default: new Header({
      children: createDocxChildren(defaultHeaderEntry, options),
    }),
    even: new Header({
      children: createDocxChildren(evenHeaderEntry, options),
    }),
    first: new Header({
      children: createDocxChildren(firstPageHeaderEntry, options),
    }),
  };
}
